

import React, { Component } from 'react';
import {Card, Row} from 'reactstrap'
import CdnImage from "../../general/cdnImage/cdnImage";

const stateManager = require('../../../../utils/state/stateManager');
const stringUtil = require('../../../../utils/string/stringUtil');

class Error extends Component 
{
    render()
    {
        return  <Row className="justify-content-center" style={{marginTop:'100px'}}>
                    <Card style={{width:'50%', borderRadius: 20, textAlign:'center', paddingLeft:'100px', paddingRight:'100px', paddingTop:'50px', paddingBottom:'50px'}}>
                    <div style={{textAlign:'center'}}>
                        <CdnImage publicId="app/webOrdering/icons/error.png" />
                    </div>
                    <Row className="justify-content-center" style={{marginTop:'15px'}}>
                        <h2>Something wrong here...</h2>
                    </Row>
                    <Row className="justify-content-center" style={{marginTop:'15px'}}>
                        {
                            stringUtil.isStringNullOrEmpty(stateManager.getStore().getState().fatalError)
                                ? "Sorry, we're having some technical issues (as you can see). We're working on getting it fixed as soon as we can."
                                : stateManager.getStore().getState().fatalError
                        }
                    </Row>
                    </Card>
                </Row>
        
    }
}

export default Error;